
import SuperagentApi from '../assets/utils/superagent'

export default class RobotService {
  static async getRobotToken(robotServer, data) {
    const formDataAPI = new SuperagentApi({ baseUrl: robotServer })
    const [err, res] = await formDataAPI.post('/prod-api/surfaceInterface/surfaceLogin', {
      data
    })
    return [err, res]
  }
  static async getRobotTask(robotServer, data) {
    const formDataAPI = new SuperagentApi({ baseUrl: robotServer })
    const [err, res] = await formDataAPI.post('/prod-api/surfaceInterface/taskExec/surfaceList', {
      data,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('robotToken')}`,
      }
    })
    return [err, res]
  }
  static async getRobotTaskDetail(robotServer, data) {
    const formDataAPI = new SuperagentApi({ baseUrl: robotServer })
    const [err, res] = await formDataAPI.post('/prod-api/surfaceInterface/taskdetailrecord/selectByExecId', {
      data,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('robotToken')}`,
      }
    })
    return [err, res]
  }
}
